import React, { useState } from 'react';
import Typewriter from './Typewriter';

const KIT_ENDPOINT = 'https://api.kit.com/v4/subscribers';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Prefer the server-side proxy (Lambda) when configured, so the API key never
// ships to the browser. Falls back to calling Kit directly with a publishable key.
const PROXY_ENDPOINT = process.env.REACT_APP_SIGNUP_ENDPOINT;

// status: 'idle' | 'submitting' | 'success' | 'error'
function Signup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === 'submitting') return;

    const trimmed = email.trim();
    if (!EMAIL_RE.test(trimmed)) {
      setStatus('error');
      setMessage('That email doesn’t look right. Mind checking it?');
      return;
    }

    const apiKey = process.env.REACT_APP_KIT_API_KEY;
    if (!PROXY_ENDPOINT && !apiKey) {
      setStatus('error');
      setMessage('Signup isn’t configured yet. Try again a little later.');
      return;
    }

    setStatus('submitting');
    setMessage('');

    try {
      const res = await fetch(PROXY_ENDPOINT || KIT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Only sent when talking to Kit directly; the proxy holds the key.
          ...(PROXY_ENDPOINT ? {} : { 'X-Kit-Api-Key': apiKey }),
        },
        body: JSON.stringify({ email_address: trimmed }),
      });

      if (!res.ok) {
        throw new Error(`Request failed with ${res.status}`);
      }

      setStatus('success');
      setMessage('You’re on the list. We’ll write when it’s worth it.');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMessage('Something went sideways. Give it another try in a moment.');
    }
  };

  return (
    <section className="signup section" aria-label="Join the mailing list">
      <div className="signup__inner">
        <p className="signup__copy">
          We're taking our time over here.{' '}
          <Typewriter className="signup__whisper" text="little money" />. Join
          the mailing list and we'll write when we have something worth saying.
        </p>

        <form className="signup__form" onSubmit={handleSubmit} noValidate>
          <label className="visually-hidden" htmlFor="signup-email">
            Email address
          </label>
          <input
            id="signup-email"
            className="signup__input"
            type="email"
            name="email"
            inputMode="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === 'submitting' || status === 'success'}
            required
          />
          <button
            className="signup__button"
            type="submit"
            disabled={status === 'submitting' || status === 'success'}
          >
            {status === 'submitting' ? 'Sending…' : 'Join'}
          </button>
        </form>

        {message && (
          <p
            className={`signup__message signup__message--${status}`}
            role={status === 'error' ? 'alert' : 'status'}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}

export default Signup;
